import React from "react";

const WITHDRAW_STATUS_HEADER = ["Date And ID", "Paid Time", "System", "Voucher Code", "Amount", "Status", "Cancel"];

const WithdrawStatus = () => {
  const WITHDRAW_STATUS_DATA = [];
  return (
    <>
      {WITHDRAW_STATUS_DATA.length ? (
        <ul className="flex p-2 rounded bg-white/10 shadow text-[12px] overflow-x-auto">
          {WITHDRAW_STATUS_HEADER.map((item, index) => (
            <li className="flex-auto min-w-[100px] text-white/70">{item}</li>
          ))}
        </ul>
      ) : (
        <div className="py-10 text-center text-white/70 text-[12px]">No Withdrawal information</div>
      )}
    </>
  );
};

export default WithdrawStatus;
